import React, { useState, useRef } from "react";
import {
  Videocam,
  Mic,
  Call,
  FiberManualRecord,
  MicOff,
  VideocamOff,
} from "@mui/icons-material";
import Avatar from "@mui/material/Avatar";
import "./customStyle.css";
import { getSocket } from "../../services/socketService";
import { useEffect } from "react";
import ChatIcon from "@mui/icons-material/Chat";
import { Grid, Typography } from "@mui/material";
import ChatComponent from "./ChatComponent";
import apiServices from "../../services/apiServices";
import {
  chatClickedInCallAction,
  presentScreen,
} from "../../Store/Buzzcom/actions";
import { useDispatch, useSelector } from "react-redux";
import { handleCallUser } from "../../Store/Buzzcom/actions";

const VideoCallComponent = React.memo((props) => {
  const {
    setUserBusy,
    userBusy,
    caller,
    localVidRef,
    muteStatus,
    remoteVidRef,
    selectedChat,
    sender,
    callAccepted,
    contacts,
    receiver,
    callEndCall,
    setIsInCall,
    otherCallerDeviceId,
    deviceId,
    isInCall,
    hasMounted,
    userIdsArray,
    setHasMounted,
    // setMuteStatus,
    platformCall,
    currentPage,
    call,
    setCall,
    setCamOff,
    camOff,
    setCurrentPage,
    callResponse,
  } = props;
  const dispatch = useDispatch();
  const [isVidOn, setVidOn] = useState(false);
  const socket = getSocket();
  const [isMicOn, setMicOn] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);
  // const [isRecording, setRecording] = useState(false);
  const [showChat, setShowChat] = useState(false);
  // const [videoPosition, setVideoPosition] = useState(false);
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const [isChatClickInCall, setIsChatClickInCall] = useState(false);
  const [recording, setRecording] = useState(false);

  const [mediaRecorder, setMediaRecorder] = useState(null);
  const videoRef = useRef(null);
  const chunksRef = useRef([]);
  const callUser = useSelector((state) => state.Buzzcom.callUser);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: { mediaSource: "screen" },
        audio: true, // Add this to request audio tracks
      });

      const recorder = new MediaRecorder(stream);
      recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          chunksRef.current.push(e.data);
        }
      };

      recorder.onstop = () => {
        const blob = new Blob(chunksRef.current, { type: "video/mp4" });
        const videoURL = URL.createObjectURL(blob);
        if (videoRef.current !== null && videoRef.current !== undefined) {
          videoRef.current.src = videoURL;
        }

        // Create a download link
        const a = document.createElement("a");
        a.href = videoURL;
        a.download = "recorded-video.mp4";
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      };

      recorder.start();
      setRecording(true);
      setMediaRecorder(recorder);
    } catch (error) {
      console.error("Error accessing screen:", error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
      setRecording(false);
    }
  };
  const toggleChat = () => {
    setShowChat(!showChat);
  };
  //   const checkCameraStatus = () => {

  //     // Check localVidRef
  //     const localVideoTracks = localVidRef.current?.srcObject?.getVideoTracks();
  //     const isLocalCameraOff = localVideoTracks && localVideoTracks.length === 0;

  //     // Check remoteVidRef
  //     const remoteVideoTracks = remoteVidRef.current?.srcObject?.getVideoTracks();
  //     const isRemoteCameraOff = remoteVideoTracks && remoteVideoTracks.length === 0;

  //     // Now you can use isLocalCameraOff and isRemoteCameraOff as needed
  //     if (isLocalCameraOff && isRemoteCameraOff) {
  // setCall({audio:true,video:false})
  //     } else {
  //       console.log('At least one camera is on.');
  //     }
  //   };

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  console.log("width is", width);

  const toggleVideo = () => {
    if (platformCall === "web") {
      if (call?.audio && !call?.video) {
        handleCallUser("videoSwitch");
        return;
      }

      if (isVidOn) {
        // setCamOff((prev) => ({ ...prev, my: false }));

        socket.emit("switchContent", {
          from: sender,
          to: receiver,
          type: "camTurnedOff",
          queryType: "switch",
        });
      } else if (!isVidOn) {
        // setCamOff((prev) => ({ ...prev, my: true }));
        socket.emit("switchContent", {
          from: sender,
          to: receiver,
          type: "camTurnedOn",
        });
      }

      // setCamOff((prev) => ({ ...prev, second: !prev.second }));

      // if (localVidRef.current && localVidRef.current.srcObject) {
      //   const videoTracks = localVidRef.current.srcObject.getVideoTracks();
      //   videoTracks.forEach((track) => {
      //     track.enabled = !isVidOn;
      //   });
      // }

      setVidOn((prevState) => !prevState);

      // navigator.mediaDevices
      //   .getUserMedia({ video: false, audio: true })
      //   .then((stream) => {
      //     // Stop existing video tracks if any
      //     if (localVidRef.current.srcObject) {
      //       localVidRef.current.srcObject
      //         .getVideoTracks()
      //         .forEach((track) => track.stop());
      //     }

      //     // Set the new stream with camera off
      //     localVidRef.current.srcObject = stream;
      //     // setCall({ audio: true, video: false });
      //     // Toggle the video tracks

      //   })
      //   .catch((error) => {
      //     console.error("Error toggling video:", error);
      //   });
    }
  };

  // useEffect(() => {
  //   if (camOff?.second) {
  //     navigator.mediaDevices
  //       .getUserMedia({ video: false, audio: true })
  //       .then((stream) => {
  //         // Stop existing video tracks if any
  //         if (localVidRef.current.srcObject) {
  //           localVidRef.current.srcObject
  //             .getVideoTracks()
  //             .forEach((track) => track.stop());
  //         }

  //         // Set the new stream with camera off
  //         localVidRef.current.srcObject = stream;
  //         // Additional logic if needed

  //         // You might want to update the state to reflect the camera status
  //         // setCamOff((prev) => ({ ...prev, second: false }));
  //       })
  //       .catch((error) => {
  //         console.error('Error turning off the camera:', error);
  //       });
  //   }
  // }, [camOff]);

  const callDisconnect = () => {
    setIsInCall(false);
    callEndCall(caller);
    dispatch(handleCallUser({}));
    dispatch(presentScreen("Messages"));
    if (!callAccepted?.accepted) {
      const payload = {
        from: sender,
        deviceId,
        to: receiver,
      };
      apiServices.sendCallWithdraw(payload);
    } else
      socket.emit("disconnectcall", {
        from: sender,
        to: receiver,
        reason: "Call Ended",
        deviceId: otherCallerDeviceId,
      });
  };
  const toggleMic = () => {
    if (isMicOn) {
      socket.emit("mute", {
        from: sender,
        to: receiver,
        type: "muted",
        deviceId,
      });
    } else {
      socket.emit("mute", {
        from: sender,
        to: receiver,
        type: "unmuted",
        deviceId,
      });
    }
    if (localVidRef.current && localVidRef.current.srcObject) {
      const audioTracks = localVidRef.current.srcObject.getAudioTracks();
      audioTracks.forEach((track) => {
        track.enabled = !isMicOn;
      });
    }
    setMicOn((prevState) => !prevState);
  };
  const toggleRecording = () => {
    setRecording((prevState) => !prevState);
  };
  const chatClick = () => {
    dispatch(chatClickedInCallAction(!isChatClickInCall));
    setIsChatClickInCall(!isChatClickInCall);
  };
  const switchVideoPositions = () => {
    const localVid = localVidRef.current;
    const remoteVid = remoteVidRef.current;

    const localVidStyles = {
      left: localVid.style.left,
      top: localVid.style.top,
      width: localVid.style.width,
      height: localVid.style.height,
      zIndex: localVid.style.zIndex,
    }; // Copy localVid styles including zIndex

    // Swap individual style properties between localVid and remoteVid
    localVid.style.left = remoteVid.style.left;
    localVid.style.top = remoteVid.style.top;
    localVid.style.width = remoteVid.style.width;
    localVid.style.height = remoteVid.style.height;
    localVid.style.zIndex = remoteVid.style.zIndex;

    remoteVid.style.left = localVidStyles.left;
    remoteVid.style.top = localVidStyles.top;
    remoteVid.style.width = localVidStyles.width;
    remoteVid.style.height = localVidStyles.height;
    remoteVid.style.zIndex = localVidStyles.zIndex;
  };

  useEffect(() => {
    const remoteVid = remoteVidRef.current;
    const localVid = localVidRef.current;

    if (camOff.other) {
      remoteVid.style.visibility = "visible";
    } else {
      remoteVid.style.visibility = "hidden";
    }
  }, [camOff.other]);

  useEffect(() => {
    const remoteVid = remoteVidRef.current;
    const localVid = localVidRef.current;

    if (isVidOn) {
      localVid.style.visibility = "visible";
    } else {
      localVid.style.visibility = "hidden";
    }
  }, [isVidOn]);

  const lowerVolume = (ref) => {
    if (ref && ref.current) {
      // Set the volume level (0.5 is 50%)
      ref.current.volume = 0;
      ref.current.muted = true; // You can adjust this value as needed
    }
  };
  useEffect(() => {
    dispatch(presentScreen(call.video ? "Video Call" : "Audio Call"));
    if (call?.audio && !call?.video) {
      setVidOn(false);
    } else {
      setVidOn(true);
    }
  }, [call]);

  // Apply lower volume when component mounts
  useEffect(() => {
    lowerVolume(localVidRef);
    // lowerVolume(remoteVidRef);
  }, []); // Run this effect only once, on component mount

  useEffect(() => {
    let interval;
    let isRunning = false;

    if (callAccepted.accepted && !isRunning) {
      isRunning = true;
      interval = setInterval(() => {
        setSecondsElapsed((prevSeconds) => {
          return prevSeconds + 1;
        });
      }, 1000);
    }

    return () => {
      clearInterval(interval);
      isRunning = false;
    };
  }, [callAccepted]);

  const hours = Math.floor(secondsElapsed / 3600);
  const minutes = Math.floor((secondsElapsed % 3600) / 60);
  const seconds = secondsElapsed % 60;

  // Format time for display
  const formattedTime = [hours, minutes, seconds]
    .map((v) => (v < 10 ? "0" + v : v))
    .join(":");

  console.log("formattedTime @@", formattedTime);

  useEffect(() => {
    // setCurrentPage(1);
    setTimeout(() => {
      // setIsRinging(false);
    }, 5000);

    return () => {
      clearTimeout();
    };
  }, []);

  return (
    <div className="callContainer">
      {call?.audio && !call?.video && (
        <div className="containerIn">
          <div className="circleContainer">
            <div className="imageContainerChat">
              <audio
                ref={localVidRef}
                autoPlay
                controls
                style={{ display: "none" }}
              />
              <audio
                ref={remoteVidRef}
                autoPlay
                controls
                style={{ display: "none" }}
              />
              <Avatar
                className="avatarSize"
                alt="Remy Sharp"
                src="/static/images/avatar/1.jpg"
              >
                {" "}
                {callUser?.contacts[1].name.charAt(0)}
              </Avatar>
              {muteStatus ? (
                <MicOff
                  className="tester1"
                  style={{ color: "white" }}
                  fontSize="medium"
                />
              ) : (
                <Mic
                  className="tester1"
                  style={{ color: "white" }}
                  fontSize="medium"
                />
              )}
            </div>
          </div>
        </div>
      )}
      {call?.video && (
        <div style={{ position: "relative" }} className="">
          <div className="containerIn">
            <div className="circleContainer">
              <div className="imageContainerChat">
                <audio
                  ref={localVidRef}
                  autoPlay
                  controls
                  style={{ display: "none" }}
                />
                <audio
                  ref={remoteVidRef}
                  autoPlay
                  controls
                  style={{ display: "none" }}
                />
                <Avatar
                  className="avatarSize"
                  alt="Remy Sharp"
                  src="/static/images/avatar/1.jpg"
                >
                  {" "}
                  {callUser?.contacts[1].name.charAt(0)}
                </Avatar>
                {!camOff.other &&
                  callAccepted?.accepted &&
                  (muteStatus ? (
                    <MicOff
                      className="tester1"
                      style={{ color: "white" }}
                      fontSize="medium"
                    />
                  ) : (
                    <Mic
                      className="tester1"
                      style={{ color: "white" }}
                      fontSize="medium"
                    />
                  ))}
              </div>
            </div>
          </div>
          <video
            style={{
              left: 0,
              objectFit: "cover",
              position: "absolute",
              top: 0,
              borderRadius: "10px",
              width: "100%",
              height: "100%",
              zIndex: 1,
            }}
            ref={remoteVidRef}
            autoPlay
            playsInline
            // onClick={switchVideoPositions}
            // controls
          />

          <video
            style={{
              position: "absolute",
              objectFit: "cover",
              zIndex: 11,
              right: 2,
              bottom: 25,
              borderRadius: "10px",
              width: "23%", // Adjusted size to fit the video
              height: "120px",
              border: "2px solid #f3f3f3",
            }}
            ref={localVidRef}
            autoPlay
            playsInline
            // onClick={switchVideoPositions}
            // controls
          />
          {camOff.other &&
            callAccepted?.accepted &&
            (muteStatus ? (
              <MicOff
                className="tester"
                style={{ color: "white" }}
                fontSize="medium"
              />
            ) : (
              <Mic
                className="tester"
                style={{ color: "white" }}
                fontSize="medium"
              />
            ))}
        </div>
      )}
      <div
        className={`${
          width > 767.9
            ? "bottom-middle"
            : "d-flex justify-content-center flex-column align-items-center"
        }`}
      >
        <div className="formattedTime">
          <p style={{ paddingTop: "10px" }}>
            {callAccepted?.accepted
              ? `Call Duration: ${formattedTime}`
              : userBusy
              ? "Busy"
              : "Ringing..."}
          </p>
        </div>
        <div className={"callButtons"}>
          <div
            className={`control-buttons ${
              isChatClickInCall ? "button-light" : ""
            }`}
            onClick={() => chatClick()}
          >
            <img src="/BuzzCom/images/chat.svg" alt="Chat" />
          </div>
          <div
            className="control-buttons control-buttonsRed colorIcon"
            onClick={() => callDisconnect()}
          >
            <img src="/BuzzCom/images/callend.svg" alt="CallEnd" />
          </div>
          <div className="control-buttons" onClick={() => toggleMic()}>
            {/* <Typography variant="" className="">
            
                  </Typography> */}

            {isMicOn ? (
              <Mic
                style={{ color: "#767676", width: "43px" }}
                fontSize="medium"
              />
            ) : (
              <MicOff style={{ color: "#767676" }} fontSize="medium" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
});

export default VideoCallComponent;
